import Vue from 'vue'
import App from './App.vue'
import view403 from './views/view403'

import router from './router'
import moment from 'moment'
import VueQuillEditor from 'vue-quill-editor'

import "bootstrap";
//import "bootstrap/dist/css/bootstrap.min.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Notifications from 'vue-notification'
import CAS from './CAS-client';
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import Healthcheck from "./views/Healthcheck";

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Notifications)
Vue.use(VueQuillEditor, /* { default global options } */)
Vue.use(Loading);

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
});

let presentarRespuesta = window.location.pathname.includes("/respuesta/")
let healthcheck = window.location.pathname.includes("/check")
if(presentarRespuesta){
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
} else if(healthcheck) {
  new Vue({
    router,
    render: h => h(Healthcheck)
  }).$mount('#app')
}else if((CAS.isAutenticated())) {
  CAS.hasPermission().then(() => {
      new Vue({
        router,
        render: h => h(App)
      }).$mount('#app')
  }).catch(() =>{
    new Vue({
      router,
      render: h => h(view403)
    }).$mount('#app')
  })
} else {
  CAS.authenticate()
}
